import '../sass/plugins.scss';

require('../../../assets/global/plugins/bootstrap/js/bootstrap.min');

window.Pace = require('pace-js');
window.Cookies = require('js-cookie');
window.jsPDF = require('jspdf');
window.toastr = require('toastr');
window.moment = require('moment');
window.PasswordValidation = require('../../../assets/global/plugins/passvalidation/passvalidation');
window.bootbox = require('../../../assets/global/plugins/bootbox/bootbox.min');

require('../../../assets/global/plugins/jquery.blockui.min');
require('../../../assets/global/plugins/icheck/icheck');
require('../../../assets/global/plugins/bootstrap-switch/js/bootstrap-switch');
require('../../../assets/global/plugins/footable/footable');
require('../../../assets/global/plugins/jquery-slimscroll/jquery.slimscroll');
require('../../../assets/global/plugins/bootstrap-multiselect/js/bootstrap-multiselect');
require('interactjs');
require('summernote');
require('jquery-contextmenu');
require('select2/dist/js/select2.full');
require('jquery-minicolors')
require('bootstrap-datepicker')
require('bootstrap-timepicker')
require('daterangepicker')

require('jquery-validation');
if (window.currentLang == "fr") {
  require('jquery-validation/dist/localization/messages_fr');
}